import React from 'react';
import { Container, Typography } from '@pwskills/rachnaui';
import Link from 'next/link';

const PrivacyPolicy = () => {
  return (
    <Container className="my-8 regular:my-14 privacy-policy">
      <Typography
        component="h1"
        variant="bold"
        className="text-center text-gray-900 pb-9 regular:!pb-14"
      >
        Privacy Policy
      </Typography>
      <Typography component="h3" variant="bold" className="font-inter pb-4">
        Introduction
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          This Privacy Policy relates to the collection, use and disclosure of personal data,
          including special or sensitive personal data, by PW Skills (&quot;
          <strong>Physics Wallah Limited</strong>
          &quot;, &quot;we&quot;, or &quot;our&quot;). Personal Data is information relating to an
          individual (&quot;you&quot; or &quot;your&quot;) as more fully defined herein below. PW
          Skills is committed to protecting your privacy and ensuring that you have a secured
          experience on our website and while using our products and services (collectively,
          &quot;Products&quot;).
        </Typography>
        <Typography component="body-regular" variant="regular">
          This policy covers the PW Skills website and all the subdomains under{' '}
          <Link href="/" className="text-linkBlue">
            pwskills.com
          </Link>
          . Please refer to the following link to read our terms of service{' '}
          <Link href="/terms-and-conditions" className="text-linkBlue">
            Terms and Conditions
          </Link>
        </Typography>
        <Typography component="body-regular" variant="regular">
          This policy outlines PW Skills&#39;s, its subsidiaries and affiliated companies handling
          practices and how we collect and use the information you provide in the course of your use
          or access of our systems through online interfaces (e.g. website, mobile applications
          etc.) (collectively &quot;Company Systems&quot;). In this Privacy Policy, &quot;Personal
          Data&quot; means any information that can be used to individually identify a person and
          may include, but is not limited to, name, email address, postal or other physical
          addresses, title, and other personally identifiable information. By using our services or
          products, it will be deemed that you have read, understood and agreed to be bound by this
          policy detailed hereunder
        </Typography>
        <Typography component="body-regular" variant="regular">
          We will be the processor of the Personal Data that is provided, collected and/or processed
          pursuant to this policy, except where otherwise expressly stated.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Applicability of the Policy
      </Typography>
      <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1">
        <li>
          <Typography component="body-regular" variant="regular">
            This policy shall apply to all information we collect through the Company Systems and/or
            in the course of your use of the services of PW Skills.
          </Typography>
        </li>
        <li>
          <Typography component="body-regular" variant="regular">
            This policy does not apply to, nor does PW Skills take any responsibility for, any
            information that is collected by any third party either using Company Systems or through
            any links on the Company Systems or through any of the advertisements or through BOTS.
          </Typography>
        </li>
      </ul>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Information We Collect
      </Typography>
      <div className="flex flex-col space-y-2">
        <Typography component="body-regular" variant="regular">
          We will only collect information which you share with us. You can choose what information
          you want to share with us. We will collect your information only if you choose to share it
          through the Company Systems. We will collect the following information about you or
          related to your use of the Company&apos;s Systems:
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1">
          <li>
            <Typography component="body-regular" variant="regular">
              Any personal or PII that you may submit or may be required to submit for registration
              and continued use of the Company Systems or receive the services by PW Skills;
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Your name, title, gender, date of birth, email address, telephone number
              (Home/work/mobile telephonic number), profile/display picture, login name, screen
              name, nickname, or handle, country/state/postcode or city of residence, postal or
              other physical address, name(s) of the school/university (including grades and
              graduation year),name(s) of the workplace, job position/designation (including
              salary), resume/CV, information related to social profiles, such as Facebook, Google,
              GitHub etc., IP addresses and other information collected passively (as further
              detailed in the &quot;Passive Collection&quot; section below), may be collected; and
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Any other information you may choose to further provide us, without limitation, any
              information to update your account and profile, if required, to fill out any forms,
              provide your feedback to surveys, write any articles on the Company Systems, or to use
              any features of Company Systems.
            </Typography>
          </li>
        </ul>
        <Typography component="body-regular" variant="regular">
          We collect and/or process your Personal Data as a part of the following activities related
          to our Products:
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1">
          <li>
            <Typography component="body-regular" variant="regular">
              Account registration, use of certain Product features, creating or taking tests,
              generating reports based on information collected from use of our Products.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Requesting service and support for our Products and providing such support,
              registering for an event, participating in an online survey, participating in
              discussion groups or forums.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Registering for newsletter subscriptions, customizing the content you see as per
              relevance.
            </Typography>
          </li>
        </ul>
        <Typography component="body-regular" variant="regular">
          Please do not include any personal information, personally identifiable information or
          sensitive personal information unless specifically requested by PW Skills as part of the
          registration or other applicable processes. If PW Skills determines that any information
          you have provided or uploaded violates the terms of this policy, PW Skills shall have the
          right, in its absolute discretion, to delete such information without incurring any
          liability.
        </Typography>
        <Typography component="body-regular" variant="regular">
          We may also periodically use your information received from your affiliated entities,
          business partners and other third-party sources and combine it with your account
          information. For example: if you access or login to our Company Systems via a third-party
          source like Facebook, Twitter, LinkedIn, we may receive your registration information,
          updated information and combine that with information we collect through our Company
          Systems or add it to your account information on our Company Systems.
        </Typography>
        <Typography component="body-regular" variant="regular">
          If You are governed by the United States laws, to the extent permitted by applicable laws,
          we may obtain reports from public records of credit history checks, criminal databases
          checks including National Criminal Database and county courts in each state, national
          government restricted lists, sex offender registrations. If you are outside of the United
          States, to the extent permitted by applicable laws, PW Skills may obtain reports of the
          respective criminal background or registered sex offender checks. To obtain such reports
          as stated herein, we may use your information, like your full name and date of birth.
        </Typography>
        <Typography component="body-regular" variant="regular">
          General Data Protection Regulation (GDPR) is designed to give EU citizens more control
          over their data. It aims to use an all-encompassing privacy and security law to safeguard
          Personal Data. Irrespective of their location, GDPR applies to all the relevant
          controllers or processors who deal with the Personal Data of EU citizens.
        </Typography>
        <Typography component="body-regular" variant="regular">
          For more information, please refer to{' '}
          <Link
            href="https://en.wikipedia.org/wiki/General_Data_Protection_Regulation"
            target="_blank"
            rel="noreferrer"
            className="text-linkBlue"
          >
            GDPR
          </Link>
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Processing your Personal Data
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          We will use your Personal Data only in accordance with this policy. To enable us to fulfil
          the contract between us for the services you have requested, we need to process your
          Personal Data for purposes including the following:
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1">
          <li>
            <Typography component="body-regular" variant="regular">
              Account registration.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Use of our website.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Creating or taking online tests.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Generating reports based on information collected from use of our Products.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Requesting service and support for our Products and providing such support.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Registering for hackathons.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Participating in discussion groups or forums.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Customizing the content you see as per relevance.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Referring your profile to relevant job opportunities.
            </Typography>
          </li>
        </ul>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        We process Personal Data for purposes such as:
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1">
          <li>
            <Typography component="body-regular" variant="regular">
              Providing reports based on information collected from use of our Products.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Keeping you up-to-date about latest Product announcements, software updates, software
              upgrades, system enhancements, special offers, and other information.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Providing support and assistance for our Products.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Providing the ability to create personal profile.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Providing the ability to contact you, if required.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Providing customer feedback and support.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Providing and administering opt-in events or other marketing or promotional activities
              on PW Skills.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Being able to conduct questionnaires and surveys in order to provide you with better
              products and services.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Supporting recruitment inquiries.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Personalizing marketing communication and website content based on your preferences,
              such as in response to your request for specific information on products and services
              that may be of interest to you.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Meeting contract or legal obligations.
            </Typography>
          </li>
        </ul>
        <Typography component="body-regular" variant="regular">
          We may allow employers to view your anonymised profile and contact you for a relevant job
          opportunity. We provide them with a channel to contact you for a relevant job opportunity.
          We share your PII with employers only with your explicit consent, or when you reply back
          to the conversation channel. If you wish to opt-out of this feature, please send us an
          email to{' '}
          <Link href="mailto:support@pwskills.com" className="text-linkBlue">
            support@pwskills.com
          </Link>
        </Typography>
        <Typography component="body-regular" variant="regular">
          We may also process your personal data where it is in our legitimate interests to seek
          professional advice, including, in connection with any legal proceedings (including any
          prospective legal proceedings), for obtaining legal advice or for establishing, exercising
          or defending legal rights.
        </Typography>
      </div>
      <Typography component="h2" variant="bold" className="font-inter pt-6">
        Consent
      </Typography>
      <Typography component="h3" variant="bold" className="font-inter py-4">
        How do we use your information?
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          PW Skills will use your Personal Data only in accordance with this policy. If you do not
          wish us to continue using your Personal Data in this manner you can request for
          deactivation of your account from account settings.
        </Typography>
        <Typography component="body-regular" variant="regular">
          We will only process your Personal Data if we have a lawful basis for doing so, which
          includes but is not limited to the following:
        </Typography>
        <Typography component="body-regular" variant="regular">
          consent, contractual necessity (i.e. processing that is necessary for the performance of a
          contract with you, such as your user agreement with us that allows us to provide you with
          the Products) and our legitimate interests or the legitimate interest of others (e.g. our
          users) such as:
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1">
          <li>
            <Typography component="body-regular" variant="regular">
              Provide you with the websites and services, together with any support you may request.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Respond to your inquiries or fulfill your requests.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Diagnose Website and Service technical problems.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Send you information that we believe may be of interest to you, such as Service.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Announcements, newsletters, educational materials, and event information.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Send you administrative information such as notices related to the Services or policy
              changes.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Understand how the Websites and Services are being used in order to enhance and
              optimize them.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Prevent, detect, mitigate, and investigate fraudulent or illegal activity.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              As described to you at the point of collection of the information.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Complying with our legal obligations, resolving disputes with users, enforcing our
              agreements.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Protecting, investigating and deterring against fraudulent, harmful, unauthorized or
              illegal activity.
            </Typography>
          </li>
        </ul>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        How do we organize &amp; store your data?
      </Typography>
      <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1">
        <li>
          <Typography component="body-regular" variant="regular">
            AWS Relational Database - Main database storing all User information.
          </Typography>
        </li>
        <li>
          <Typography component="body-regular" variant="regular">
            ElasticSearch - Indexed resumes. We use it to query on text written in a user&#39;s
            resume.
          </Typography>
        </li>
        <li>
          <Typography component="body-regular" variant="regular">
            Sentry - Used to monitor errors.
          </Typography>
        </li>
        <li>
          <Typography component="body-regular" variant="regular">
            New Relic - Stores server logs which are used in optimization of our services.
          </Typography>
        </li>
        <li>
          <Typography component="body-regular" variant="regular">
            S3 - Server logs and User resume files.
          </Typography>
        </li>
        <li>
          <Typography component="body-regular" variant="regular">
            Google Analytics - The third-party services described in this section enable PW Skills
            to monitor and analyze Website and Service traffic. Google Analytics (Google Inc.)
            Google Analytics is a web analysis service provided by Google Inc. Google utilizes the
            information collected to track and examine the use of the Websites and Services to
            prepare reports that may be used for optimization of the Websites and Services.
            Information collected: Cookies and usage data.
          </Typography>
        </li>
        <li>
          <Typography component="body-regular" variant="regular">
            Place of processing: United States.
          </Typography>
        </li>
      </ul>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Your Rights:
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          Rights: You have certain rights with respect to your Personal Data as mentioned below.
        </Typography>
        <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1">
          <li>
            <Typography component="body-regular" variant="regular">
              Access: You can request more information about the Personal Data we hold about you.
              You can also request a copy of the Personal Data.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Correction: If you believe that any Personal Data we are holding about you is
              incorrect or incomplete, you can request that we correct or supplement such data. You
              can also correct some of this information directly through your user profile or
              profile/account settings after logging into PW Skills. Please contact us as soon as
              possible upon noticing any inaccuracies or incompleteness.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Objection: You can contact us to let us know that you object to the collection or use
              of your Personal Data for certain purposes.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Erasure: You can request that we delete some or all of your Personal Data from our
              systems. While this will be done immediately, residual data may be saved in certain
              logs and this will be purged within a year after deleting your data. Once your data is
              deleted, you will no longer have an account with PW Skills.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Restrictions: You can always request us to deactivate your PW Skills account to
              restrict further processing of your Personal Data
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Portability: You have the right to ask for a copy of your Personal Data in a machine-
              readable format.
            </Typography>
          </li>
          <li>
            <Typography component="body-regular" variant="regular">
              Withdrawal of consent: If we are processing your Personal Data based on your consent
              (as indicated at the time of collection of such data), you have the right to withdraw
              your consent at any time. Please note, however, that if you exercise this right, you
              may have to then provide express consent on a case-by-case basis for the use or
              disclosure of certain of your Personal Data, if such use or disclosure is necessary to
              enable you to utilize some or all of our Products.
            </Typography>
          </li>
        </ul>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Retention
      </Typography>
      <Typography component="body-regular" variant="regular">
        Your data is retained with PW Skills as long as you have an active account on the Company
        Systems. You can delete all of your Personal Data from our systems from your account profile
        page. Residual data may be saved in certain logs and this will be purged within a year after
        deleting your data. Once your data is deleted, you will no longer have an account with PW
        Skills.
      </Typography>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Passive Data collection:
      </Typography>
      <Typography component="body-regular" variant="regular">
        PW Skills might automatically collect some data about you when you are using any of our
        products, using methods like cookies and other tracking technologies. Information
        automatically collected includes cookies, page views, geolocation data, IP(internet
        protocol) addresses, browser and OS(Operating System) type, ISP (Internet Service Provider),
        files viewed and downloaded from our websites, referral and exit pages and click stream
        data. Such data does not have an expiry date and we do not delete this data. This data is
        stored in the form of logs or in third party tracking and analytics softwares like Google
        analytics, Linkedin Insights etc.
      </Typography>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        We Use Cookies:
      </Typography>
      <ul className="pl-5 list-disc space-y-0.5 regular:space-y-1">
        <li>
          <Typography component="body-regular" variant="regular">
            PW Skills uses cookies to help us remember and process the items in your shopping cart.
            They are also used to help us understand your preferences based on previous or current
            site activity, which enables us to provide you with improved services. We also use
            cookies to help us compile aggregate data about site traffic and site interaction so
            that we can offer better site experiences and tools in the future. Further, we may use
            cookies or other tracking technologies to analyze trends, track users&apos; movements
            around the website, and gather information about our user base, such as location
            information based on IP addresses.
          </Typography>
        </li>
        <li>
          <Typography component="body-regular" variant="regular">
            You can choose to have your computer warn you each time a cookie is being sent, or you
            can choose to turn off all cookies. You do this through your browser (like Internet
            Explorer) settings. Each browser is a little different, so look at your browser&#39;s
            Help menu to learn the correct way to modify your cookies.
          </Typography>
        </li>
        <li>
          <Typography component="body-regular" variant="regular">
            If you disable cookies off, some features will be disabled. It won&#39;t affect the
            user&#39;s experience that makes your site experience more efficient and some of our
            services will not function properly.
          </Typography>
        </li>
        <li>
          <Typography component="body-regular" variant="regular">
            PW Skills may collect information related to visitors and machines. Such information
            includes cookies, IP addresses, pageview activities, and geolocation data. The details
            of user activities on our website such as number of visits, time spent on our website,
            and pages clicked are also collected.
          </Typography>
        </li>
      </ul>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        To whom we may disclose your Personal Data:
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          General: The information you provide on the Company Systems may be disclosed by PW Skills
          to its employees, agents, representatives, consultants, subsidiaries, affiliates and
          third-party providers who require the information for the purposes of (a) operating and
          maintaining the Company Systems, (b) data processing or storage.
        </Typography>
        <Typography component="body-regular" variant="regular">
          Hiring Partners: We may provide your data to our hiring partners after taking your
          consent. We provide resumes, phone numbers, email addresses and other relevant information
          to our hiring partners to enable users to get job offers. Events of Reorganization: In any
          given instance, if PW Skills undergoes any events of reorganization, merger, acquisition,
          insolvency or bankruptcy, PW Skills may sell, transfer or share some or all of our assets,
          including your information, subject to notification to You pertaining to transfer of Your
          information.
        </Typography>
        <Typography component="body-regular" variant="regular">
          Applicable Laws: PW Skills will comply with requests and directions of all governmental,
          law enforcement, court or regulatory authorities, which it believes in good faith to be in
          accordance with any applicable law. Such compliance may include disclosing to the
          governmental, law enforcement, courts, or regulatory authorities&apos; information
          submitted by you or collected in relation to your use of the Company Systems or PW
          Skills&#39;s services including any personally identifiable information. By using the
          Company Systems and receiving PW Skills services, you consent to PW Skills&#39;s
          disclosure of information as set out in this Section herein to governmental, law
          enforcement, courts or regulatory authorities
        </Typography>
        <Typography component="body-regular" variant="regular">
          PW Skills will not publish, sell or rent Your personal information to third-parties for
          their marketing purposes without Your explicit consent.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Data Security:
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          The information that you provide, subject to disclosure in accordance with this policy,
          shall be maintained in a safe and secure manner. Your information shall be protected, to a
          commercially reasonable extent, against unauthorized access, use, or disclosure. Our
          databases and information are stored on secure servers with appropriate firewalls.
          Further, we use vulnerability scanning and scanning to PCI standards annually and our
          Company Systems are subject to regular Malware Scanning. Additionally, we use SSL
          certificate to encrypt all the data being transferred.
        </Typography>
        <Typography component="body-regular" variant="regular">
          As a user of the Company Systems, you have the responsibility to ensure data security. You
          must not disclose to any person the authentication parameters that are assigned to you
          including Your username or password for your use of the Company Systems. You acknowledge
          that you will be solely responsible for all acts committed by use of your username /other
          authentication parameters.
        </Typography>
        <Typography component="body-regular" variant="regular">
          Given the nature of internet transactions, PW Skills does not take any responsibility for
          the transmission of information collected from you or are generated by your use of the
          Company Systems or the services. Any transmission of such information over the internet is
          done at your sole risk. PW Skills does not take any responsibility for you or any third
          party circumventing the privacy settings or security measures contained on the Company
          Systems.
        </Typography>
        <Typography component="body-regular" variant="regular">
          Notwithstanding anything to the contrary, while PW Skills will use all reasonable efforts
          to ensure that any information collected from you or are generated by your use of the
          Company Systems or the services is safe and secure, it offers no representations or
          warranties that the security measures are adequate, safe, fool proof or impenetrable.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Integration with Linked Websites and Third-Party Websites:
      </Typography>
      <Typography component="body-regular" variant="regular">
        Links to external, or third-party websites, may be provided solely for your convenience.
        Such links from us to an external website does not imply or mean that PW Skills endorses or
        accepts any responsibility for the content or the use of such a website. PW Skills does not
        give any representation regarding the quality, safety, suitability, or reliability of any
        external websites or any of the content or materials contained in them. It is important for
        you to take necessary precautions, especially to ensure appropriate safety from viruses,
        worms, Trojan horses and other potentially destructive items.
      </Typography>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Third-party Ad Networks:
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        <Typography component="body-regular" variant="regular">
          Our Website may use third party network advertisers to display advertisements about our
          Products on third party websites, based on your visits to our site as well as other
          websites. This enables us and these third parties to target advertisements by displaying
          ads for our Products which might interest you.
        </Typography>
        <Typography component="body-regular" variant="regular">
          Third party network advertisers&apos; services may use cookies, JavaScript, and other
          technologies to make their ads effective and to personalize them to connect to you. These
          third-party cookies and other technologies are governed by each third party&apos;s
          specific privacy policy, and not this one. We may provide these third-party advertisers
          with anonymized and aggregated information about your usage of our website and our
          Products; however, we do not share your Personal Data with these third parties. You also
          have the option of denying the access of data to such third-party ad networks.
        </Typography>
      </div>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Anonymized Information:
      </Typography>
      <Typography component="body-regular" variant="regular">
        Notwithstanding anything to the contrary in this policy, PW Skills may use any information
        provided to PW Skills in relation to or as part of the services in providing services to its
        other clients and to develop and create reports, statistical analysis, and benchmarking
        analyses for its clients provided that such reports contain only anonymous, aggregated data
        and do not identify you by name.
      </Typography>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Age Restrictions:
      </Typography>
      <Typography component="body-regular" variant="regular">
        You explicitly agree you are 18 years of age or older, unless represented by a parent or
        legal guardian. If you are not of the requisite age you must not provide any information to
        PW Skills directly or by way of usage of the Company Systems. If PW Skills determines that
        it is in possession of any information belonging to an individual below 18 years of age
        which is submitted, collected or generated in breach of the terms of this Policy, it will
        delete the same without any notice to the individual to whom such information belongs to.
      </Typography>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Update
      </Typography>
      <Typography component="body-regular" variant="regular">
        This policy may be updated from time-to-time so we recommend that you regularly review this
        policy each time you return to our website.
      </Typography>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Grievance:
      </Typography>
      <Typography component="body-regular" variant="regular">
        If you have any issue or grievance with respect to our policy or with the manner in which we
        collect or store your information, or in any respect related to your personal information
        provided to us, please contact our Grievance Officer at{' '}
        <Link href="mailto:support@pwskills.com" className="text-linkBlue">
          support@pwskills.com
        </Link>{' '}
        . We will do everything we reasonably can to ensure that your grievance is attended to and
        addressed within a period of 30 days from the date of receipt of Your grievance.
      </Typography>
      <Typography
        component="h3"
        variant="bold"
        className="font-inter pt-4 regular:pt-6 pb-3 regular:pb-4"
      >
        Contact:
      </Typography>
      <Typography component="body-regular" variant="regular">
        This policy must be read in conjunction with the other agreements you may enter into with PW
        Skills and the ToS as published by PW Skills on PW Skills&#39;s website. By accepting the
        policy, you expressly consent to PW Skills&#39;s use and disclosure of your personal
        information in accordance with this policy.
      </Typography>
    </Container>
  );
};

export default PrivacyPolicy;
